module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/doctor01-51dc9f6e0d1a7bb87cae603a83331719.png";